import { toast } from "../../components/CommonComponents/ToastComponent/toast"
import {
    callPost,
    callGet
} from "../../services/axios"

export const getPartnerSubmissions = ({ type = 'all', filterValue, search = '', sortColumn = '', sortType = '', limit = 10, offset = 0, filters, isGetFailedFullAddress = null }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    var filterData = JSON?.stringify(filters)
    return callGet(`/api/partnerSubmission/getPartnerSubmissions`, token, { type, filterValue, search, sortColumn, sortType, limit, offset, filters, isGetFailedFullAddress }).then(res => {
        return Promise.resolve(res['data'])
    }).catch((err) => {
        toast.show({
            title: 'Warning',
            description: 'Failed to get partner Submissions!',
        })
        return Promise.reject(err)
    })
}

export const getDbmQaPartnerSubmissions = ({ sortColumn = '', sortType = '', limit = 10, offset = 0, searchData = {} }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callGet(`/api/partnerSubmission/getDbmQaPartnerSubmissions`, token, { sortColumn, sortType, limit, offset, searchList: JSON?.stringify(searchData) }).then(res => {
        return Promise.resolve(res['data'])
    }).catch((err) => {
        toast.show({
            title: 'Warning',
            description: 'Failed to get DBM QA partner Submissions!',
        })
        return Promise.reject(err)
    })
}

export const approvePartnerSubmission = ({ submissionId }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/partnerSubmission/approvePartnerSubmission`, { submissionId }, token).then(res => {
        return Promise.resolve(res['data'])
    }).catch((err) => {
        return Promise.reject(err)
    })
}

export const rejectPartnerSubmission = ({ submissionIds }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/partnerSubmission/rejectPartnerSubmission`, { submissionIds }, token).then(res => {
        return Promise.resolve(res['data'])
    }).catch((err) => {
        return Promise.reject(err)
    })
}

export const approvePartnerSubmissionAfterRerun = (submissionId, matchedSupplier, masterId, status = 'Automatic') => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/partnerSubmission/approvePartnerSubmissionAfterRerun`, { submissionId, matchedSupplier, masterId, status }, token).then((res) => {
        return Promise.resolve(res['data'])
    }).catch(err => {
        return Promise.reject({ err })
    })
}

export const removeMatchedSupplierForPartnerSubmission = ({ partnerSubmissionIds, listSupplierIds }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/partnerSubmission/removeMatchedSupplierForPartnerSubmission`, { partnerSubmissionIds, listSupplierIds }, token).then((res) => {
        return Promise.resolve(res['data'])
    }).catch(err => {
        return Promise.reject({ err })
    })
}

export const getAllRemainingPartnerSubmissionIds = ({ checkedIds }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callGet(`/api/partnerSubmission/getAllRemainingPartnerSubmissionIds`, token, { checkedIds }).then(res => {
        return Promise.resolve(res['data'])
    }).catch((err) => {
        toast.show({
            title: 'Warning',
            description: 'Failed to get partner Submissions Id!',
        })
        return Promise.reject(err)
    })
}

export const createAutoMastersForPartnerSubmissions = ({ partnerSubmission }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/partnerSubmission/createAutoMastersForPartnerSubmissions`, { partnerSubmission }, token).then((res) => {
        return Promise.resolve(res['data'])
    }).catch(err => {
        return Promise.reject({ err })
    })
}

export const needMoreInformationForPartnerSubmission = ({ partnerSubmissionId }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/partnerSubmission/needMoreInformationForPartnerSubmission`, { partnerSubmissionId }, token).then((res) => {
        return Promise.resolve(res['data'])
    }).catch(err => {
        return Promise.reject({ err })
    })
}

export const updatePartnerSubmissionAddress = ({ partnerSubmissionId, partnerSubmissionData }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/partnerSubmission/updatePartnerSubmissionAddress`, { partnerSubmissionId, partnerSubmissionData }, token).then((res) => {
        return Promise.resolve(res['data'])
    }).catch(err => {
        return Promise.reject({ err })
    })
}